import { Component, OnInit } from '@angular/core';
import { Platform, NavController, NavParams } from 'ionic-angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { SuiviObservationComponent } from '../suivi-observation/suivi-observation';
import { HomepageComponent } from '../home/home';

import { API } from '../../app/config';

@Component({
  selector: 'page-details-observation',
  templateUrl: './details-observation.html'
})
export class DetailsObservationComponent implements OnInit {
    details: Array<any> = [];
    listeObservations: Array<any> = [];
    num: number;

    constructor(
        public api: API, 
        private platform: Platform,
        private ga: GoogleAnalytics,
        private navCtrl: NavController,
        private navParams: NavParams
    ) {
        this.platform.ready().then(_ => {
            this.ga.trackView("Détails observations");
        });
    }

    ngOnInit(): any {
        this.num = this.navParams.get("details") || 0;
        this.listeObservations = this.navParams.get("listeObservations") || [];
        if (this.num > 0 && this.listeObservations.length > 0) {
            this.details = this.listeObservations[this.num];
        } else {
            this.navCtrl.push(HomepageComponent);
        }
    }

    swipeEvent(e): any  {
        if (this.listeObservations.length > 0) {
            if (e.direction == 2) {
                this.num = (this.listeObservations.length <= this.num + 1) ? 0 : this.num++;
            } else if (e.direction == 4) {
                this.num =  (0 > this.num - 1) ? this.listeObservations.length - 1 : this.num--;
            }
            this.details = this.listeObservations[this.num];
        }
    }

    goBack(): any {
        this.navCtrl.pop();
    }

    goToPageFollow(): any {
        this.navCtrl.push(SuiviObservationComponent, { details: this.details });
    }
}



// WEBPACK FOOTER //
// ./src/pages/details-observation/details-observation.ts